import { Grid } from '@mui/material'
import { ButtonBasic, CardPreServicioItem } from '../../../components'
import usePermisos from '../../../hooks/usePermisos';
import AddIcon from '@mui/icons-material/Add';
import { showModal } from 'react-redux-modal-provider';
import ModalSelectPlanes from '../../../modals/tratos/ModalSelectPlanes';
const TabContactoPreServicio = ({trato, cuenta,datosOK,datosFaltantes, onGuardar}) => {
    const permisos = usePermisos();
    const onOpenModalEditarPlan = () => {
        showModal(ModalSelectPlanes,{preServicio: trato, onGuardar:onGuardar } )
    }
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <ButtonBasic
                    variant='wk'
                    color='nextStep'
                    textButton='Editar Plan'
                    iconStart={<AddIcon />}
                    fullWidth
                    onClick={()=>onOpenModalEditarPlan()}
                    sx={{maxWidth:150}}
                />
            </Grid>
            {trato?.tratoserv && trato?.tratoserv?.length > 0 && (
                trato.tratoserv.map((preS)=>(
                    <Grid item xs={12} key={`${preS?.id_ds}grid`}>
                        <CardPreServicioItem item={preS} cuenta={cuenta} permisos={permisos} datosOK={datosOK} datosFaltantes={datosFaltantes} />
                    </Grid>
                ))
            )}
        </Grid>
    )
}

export default TabContactoPreServicio